export default __webpack_public_path__ + "static/media/Lip_10_F.4dfa136b.svg";